<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>投诉建议</li>
            </ul>
        </div>
        <div class="mainindex" style="width:1100px;">
            <div class="welinfo">
                <div class="welinfo" style="margin-bottom: 10px;">
                    <img src="../images/message1.jpg" alt="提醒" />
                </div>
                <ul class="infolist" style="width:720px;">
                    <li><b style="font-size: 13px;">1.分机一在哪里验证？</b></li>
                    <li><span style="margin-left: 20px;">（1）注册完成后。登录到自己的账户。</span></li>
                    <li><span style="margin-left: 20px;">（2）左侧导航--账户设置--基本信息，您可通过”电话验证“或”短信验证“验证分机一。</span></li>
                    <li><b style="font-size: 13px;">2.要怎么充值？最少可以充值多少？</b></li>
                    <li><span style="margin-left: 20px;">您可以通过网银或支付宝在www.yunkefu.cn直接充值，或联系客服。第一次充值金额最少100元起。</span></li>
                    
                    <li><b style="font-size: 13px;">3.短信收不到怎么办?排查方法</b></li>
                    <li><span style="margin-left: 20px;">1、接收号码正确否, 账户余额是否充足。号码文件格式是否正确。（号码格式要求详见发短信页面）</span></li>
                    <li><span style="margin-left: 20px;">2、是否欠费停机，当时不在服务区，或基站信号屏蔽有问题，可试拨打，建议手机可以关机重新开机</span></li>
                    <li><span style="margin-left: 20px;">3、安装过短信过滤软件否，如360 、QQ手机管家之类</span></li>
                    <li><span style="margin-left: 20px;">4、有否投诉过，被列入运营商白名单、黑名单、红名单</span></li>
                    <li><span style="margin-left: 20px;">5、是否使用的通道有延时，节假日可能拥堵</span></li>
                    <li><span style="margin-left: 20px;">6、内容有否包含关键敏感字，政治、诈骗、中奖、抽奖等过于广告夸张字眼，被当地接收运营商屏蔽</span></li>
                    <li><b style="font-size: 13px;">以上自查皆无问题，可再联络云客服客服</b></li>
                    <span></span>
                </ul>
                <ul class="infolist" style="float:right;margin-top:-600px;">
                    <img src="../images/message2.jpg" alt="提醒" />
                    <li><b>留言内容</b></li>
                    <li><textarea cols="" rows="" v-model="message" style="height:100px; padding:10px; width:350px; resize: none; font-family:'微软雅黑'; font-family:'Microsoft YaHei'; border: solid 1px #e1e1e1;"></textarea></li>
                    <li><input class="sure" type="button" value="发表留言" @click="submitmessage()" style="margin-top:105px;"></li>
                </ul>
            </div>
        </div>
        <div class="xline" style="width:100%;"></div>
        <span></span>
    </div>
</template>

<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            message: '',
        }
    },
    methods: {
        submitmessage() {
            if(this.message == '')
            {
                this.$alert("留言内容不能为空！");
                return false;
            }
            var that = this
            let param = {'message': this.message == null ? "" : this.message}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/top/message.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert("发表成功，感谢您的留言！");
                    that.message = '';
                }
                else
                {
                    that.$alert(res.data.msg);
                    return false;
                }
            })
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/message.vue